import React from "react";
import cn from "classnames";
import styles from "./File.module.sass";
import Icon from "../Icon";
import Tooltip from "../Tooltip";

const File = ({ className, label, tooltip, title, onChange, accept }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (onChange) {
      onChange(file);
    }
  };

  return (
    <div className={cn(styles.file, className)}>
      {label && (
        <div className={styles.label}>
          {label}{" "}
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon="info"
              place="right"
            />
          )}
        </div>
      )}
      <div className={styles.wrap}>
        <input 
          className={styles.input} 
          type="file" 
          onChange={handleFileChange}
          accept={accept || ".pdf,.doc,.docx"}
        />
        <div className={styles.box}>
          <Icon name="upload" size="24" />
          {title}
        </div>
      </div>
    </div>
  );
};

export default File;
